import styled from "styled-components";
import { up } from "styled-breakpoints";
import Link from "../../Link";

interface ButtonProps {
  color: string;
}

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  max-width: 1440px;
  margin: auto;

  ${up("tablet-portrait")} {
    flex-direction: row;
  }
`;

export const SubContainer = styled.div`
  position: relative;
  width: 100%;

  ${up("tablet-portrait")} {
    width: 50%;
  }
`;

export const MetaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${up("tablet-portrait")} {
    width: 50%;
    padding: 0 2.5rem;
  }

  ${up("tablet-landscape")} {
    padding: 0 4.563rem;
  }

  ${up("laptop")} {
    padding: 0 5.563rem;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  border-bottom-right-radius: 22% 34%;
  overflow: hidden;

  ${up("tablet-portrait")} {
    padding: 0 1rem 0 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 22% 34%;
  }

  .desktop-radius {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 22% 34%;
  }

  .mobile-radius {
    border-bottom-right-radius: 22% 34%;
  }
`;
